'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.hourFromNow;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/number/hourFromNow.js
// module id = 166
// module chunks = 0